module.exports = __webpack_public_path__ + "img/Weapon_253.b71631d8.png";